import React from 'react'
import './CardGrid.css'

function CardGrid({ children, className }) {
    return <section className={`cardGrid ${className}`}>{children}</section>
}

export default CardGrid
